export default __webpack_public_path__ + "static/media/018-kitchen-hood.fb3b5b26.png";